import { useRoles } from '../../../hooks/useRoles';
import { USER_ROLES } from '../../../constants/roles';
import AgentAccountMenu from './AgentAccountMenu';
import PlayerAccountMenu from './PlayerAccountMenu';

const menuMap = {
  [USER_ROLES.PLAYER]: PlayerAccountMenu,
  [USER_ROLES.AGENT]: AgentAccountMenu,
  [USER_ROLES.ADMIN]: AgentAccountMenu,
  [USER_ROLES.SUPER_ADMIN]: AgentAccountMenu,
  [USER_ROLES.MANAGER]: AgentAccountMenu,
  [USER_ROLES.TRADER]: AgentAccountMenu,
  [USER_ROLES.TECH_SUPPORT]: AgentAccountMenu,
};

const RoleBasedAccountMenu = () => {
  const { role } = useRoles();

  const MenuComponent = menuMap[role] || PlayerAccountMenu;

  return <MenuComponent />;
};

export default RoleBasedAccountMenu;
